function friendlyFloatingPoint(n) {
    if(n == null) return '-'
    if (n < 10) return n.toFixed(2).replace(".", ",")
    else return n.toFixed(0).replace(".", ",")
}

export default friendlyFloatingPoint